declare var pushGTMData

export function triggerGTM(name: string, step: string, event: string) {
	pushGTMData({ form: { name, step }, event })
}

export async function triggerGTMPurchase(userId: number, amount: string, userEmail: string, invoiceId: string, firstPurchase: boolean) {
	const purchaseData = await buildPurchaseData(userId, amount, userEmail, invoiceId, firstPurchase, Math.random())

	pushGTMData(purchaseData)

	if (firstPurchase) {
		pushGTMData({...purchaseData, event: 'firstPurchase'})
	}
}

export async function triggerGTMLogin(userId: string, userEmail: string) {
	const emailHashed = await hash(userEmail.trim())
	const emailAliasRemovedHashed = await getAliasRemovedHashedEmail(userEmail.trim())
	const userIdHashed = await hash(userId)

	const payload = {
		event: 'LoginCompleted',
		emailHashed: emailHashed,
		emailAliasRemovedHashed: emailAliasRemovedHashed,
		accountId: userId,
		accountIdHashed: userIdHashed
	}
	pushGTMData(payload)
}

export async function triggerGTMCompleteRegistration(userEmail: string) {
	const hashedEmail = await hash(userEmail.trim())

	pushGTMData({
		event: 'CompleteRegistration',
		form: {
			name: 'register',
			step: 'complete'
		},
		hashedUserEmail: hashedEmail
	})
}

export async function getAliasRemovedHashedEmail(email: string): Promise<string> {
	const formattedEmail = email.toLowerCase()
	const emailDomain = formattedEmail.split('@')[1]

	const plusIndex = formattedEmail.indexOf('+')
	const emailAliasRemoved = plusIndex != -1 ? `${formattedEmail.substring(0, plusIndex)}@${emailDomain}` : formattedEmail

	return await hash(emailAliasRemoved)
}

async function buildPurchaseData(userId: number, amount: string, userEmail: string, invoiceId: string, firstPurchase: boolean, random: number) {
	return {
		event: 'purchase',
		description: `purchase from userId[${userId}] firstPurchase[${firstPurchase}]`,
		transactionId: invoiceId,
		userId: userId,
		hashedUserId: await hash(`POK-${userId}`), // Must match Payments Platform userId.
		transactionTotal: amount,
		firstPurchase,
		purchaseCurrency: 'USD',
		hashedUserEmail: await hash(userEmail),
		random,
	}
}

async function hash(value: string) : Promise<string> {
	const msgUint8 = new TextEncoder().encode(value)                           
	const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8)          
	const hashArray = Array.from(new Uint8Array(hashBuffer))                     
	const hashHex = hashArray.map(x=>(('00'+x.toString(16)).slice(-2))).join('')
	return hashHex
}
